import React from 'react';
import VisuallyHidden from '@reach/visually-hidden';
import {Trans} from '@lingui/react';

import iconify from '../iconify';

import s from '../../../styles/base.css';

const GearsIcon = ({customColor, ...props}) => (
  <>
    <VisuallyHidden>
      <Trans id="icon.settings">Icona impostazioni</Trans>
    </VisuallyHidden>
    <svg viewBox="0 0 24.14 24.14" {...props} aria-hidden="true">
      <path
        d="M9.67.75l-.31,2.8A9.56,9.56,0,0,0,8.21,4L6,2.27,2.27,6,4,8.21a9.56,9.56,0,0,0-.47,1.15l-2.8.31V15l2.8.31A9.71,9.71,0,0,0,4,16.43l-1.75,2.2L6,22.37l2.2-1.76a8.22,8.22,0,0,0,1.15.48l.31,2.8H15l.31-2.8a8.34,8.34,0,0,0,1.16-.48l2.2,1.76,3.73-3.74-1.75-2.2a9.71,9.71,0,0,0,.47-1.16l2.8-.31V9.67l-2.8-.31a9.56,9.56,0,0,0-.47-1.15L22.36,6,18.63,2.27,16.43,4a9.71,9.71,0,0,0-1.16-.47L15,.75ZM12.32,7A5.29,5.29,0,1,1,7,12.32H7A5.29,5.29,0,0,1,12.32,7Z"
        transform="translate(-0.25 -0.25)"
        fill="none"
        stroke={customColor ? customColor : '#ea4154'}
        strokeWidth="1.5px"
      />
    </svg>
  </>
);

export default iconify(GearsIcon);
